import { render, staticRenderFns } from "./expiredvip-list.vue?vue&type=template&id=5f01cd7f&"
import script from "./expiredvip-list.vue?vue&type=script&lang=js&"
export * from "./expiredvip-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports